export class Vertex {
    public x: number;
    public y: number;
    constructor() {
        this.x = 0;
        this.y = 0;
    }
}
